module.exports = __webpack_public_path__ + "img/sweden.d22aa877.svg";